export function cleanObject(val: any) {
  if (!val) { return val; }
  if (typeof val === 'object') {
    Object.keys(val).map(k => val[k] = typeof val[k] === 'string' ? val[k].trim() : val[k]);
  }
  return val;
}
